module.exports = __webpack_public_path__ + "img/prioritas_vippack_dg.f4dc2c6b.png";